import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {notificationOptOut_template} from "../components/templates/notificationOptOut_template";

declare var ko: any;
declare var page: any;

export class notificationOptOut extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected notificationOptOut_template: notificationOptOut_template;

    protected getModuleName(){
        return "notificationOptOut";
    }

    buildContent() : Array<Element>{

        this.notificationOptOut_template = new notificationOptOut_template("notificationOptOut", this.viewModel, this);
        return [this.notificationOptOut_template.build()];
    }

    fillPage() : void{

        this.validateToken();
    }

    protected validateToken(){

        let token: string;

        if(token = this.getVnAppZone().app.params.token){

            this.notificationOptOut_template.getTemplateViewModel().processingToken("block");

            let validateReq_url: string = '/api/notification/notificationOptOut/token/' + token + '/';
            let validateReq_params: Array<Array<string>> = [];

            this.XHRHdl = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.showValidateTemplate;
            this.XHRHdl.execute();
        }
    }

    protected showValidateTemplate(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.notificationOptOut_template.getTemplateViewModel().processingToken("none");

                if (responseParsed.status == 200) {

                    obj.notificationOptOut_template.getTemplateViewModel().optOutComplete("block");
                }else {

                    obj.notificationOptOut_template.getTemplateViewModel().invalidToken("block");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/notificationOptOut.ts